interface OutlineExclamationIconProps {
    color: string
    height: string
    width: string
}
export default function OutlineExclamationIcon({
    color,
    height,
    width
}: OutlineExclamationIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            fill="none"
        >
            <path
                d="M7.99173 12.1391C8.24652 12.1391 8.45687 12.0589 8.62279 11.8986C8.78869 11.7382 8.87164 11.5306 8.87164 11.2758C8.87164 11.021 8.78963 10.8088 8.62561 10.6392C8.46158 10.4697 8.25217 10.3849 7.99737 10.3849C7.74257 10.3849 7.53222 10.4696 7.3663 10.6389C7.2004 10.8082 7.11745 11.0203 7.11745 11.2751C7.11745 11.5299 7.19946 11.7376 7.36349 11.8982C7.52751 12.0588 7.73692 12.1391 7.99173 12.1391ZM7.28783 8.92367H8.81709V3.85416H7.28783V8.92367ZM8.00119 16C6.89179 16 5.85253 15.7915 4.88341 15.3746C3.91431 14.9577 3.06658 14.3861 2.34023 13.6598C1.6139 12.9334 1.04228 12.0857 0.625366 11.1166C0.208455 10.1476 0 9.1078 0 7.99731C0 6.88682 0.208455 5.84653 0.625366 4.87646C1.04228 3.90639 1.61333 3.06121 2.33853 2.34093C3.06372 1.62064 3.91112 1.05042 4.88073 0.63025C5.85032 0.210083 6.89068 0 8.00179 0C9.11288 0 10.1539 0.2098 11.1248 0.6294C12.0958 1.049 12.9411 1.61846 13.6608 2.33778C14.3806 3.0571 14.9504 3.90297 15.3702 4.87538C15.7901 5.84779 16 6.88944 16 8.00032C16 9.11072 15.7899 10.1504 15.3697 11.1194C14.9496 12.0884 14.3794 12.9344 13.6591 13.6575C12.9388 14.3806 12.0931 14.9518 11.122 15.3711C10.1508 15.7904 9.11058 16 8.00119 16ZM8.0042 14.4707C9.79615 14.4707 11.3201 13.8419 12.576 12.5841C13.8319 11.3263 14.4598 9.79689 14.4598 7.9958C14.4598 6.20385 13.8331 4.67992 12.5796 3.42402C11.3261 2.16811 9.79594 1.54016 7.98908 1.54016C6.19994 1.54016 4.67601 2.16691 3.4173 3.42041C2.1586 4.67389 1.52926 6.20406 1.52926 8.01092C1.52926 9.80006 2.15814 11.324 3.41591 12.5827C4.67368 13.8414 6.20311 14.4707 8.0042 14.4707Z"
                fill={color}
            />
        </svg>
    )
}
